<div class="step-box">
	<div class="row">
		<div class="filter-header">
			<span><strong><span
				jhiTranslate="multi-trait-query.panel.specify.and.weight.the.environments.environment.filter.title"></span></strong></span>
			<span *ngIf="!hasFilterApplied()" class="filter-status"><em><span
				jhiTranslate="multi-trait-query.panel.specify.and.weight.the.environments.environment.filter.no.applied"></span></em></span>
		</div>
		<div class="button-row">
			<div class="button-group-left">
				<button (click)="openLocationFilterModal()" class="btn btn-info"><span
					jhiTranslate="multi-trait-query.panel.specify.and.weight.the.environments.environment.filter.location.title"></span>
				</button>
				<button (click)="openStudyFilterModal()" class="btn btn-info"><span
					jhiTranslate="multi-trait-query.panel.specify.and.weight.the.environments.environment.filter.study.title"></span>
				</button>
			</div>
		</div>

		<div class="row">
			<label>
				<strong>
					<span jhiTranslate="multi-trait-query.panel.specify.and.weight.the.environments.environment.choose"></span>
				</strong>
			</label>
			<div class="row mt-2 mb-2">
				<div class="col-8">
					<div class="mb-3 d-flex align-items-center">
						<jhi-item-count [page]="page" [total]="totalItems" [itemsPerPage]="itemsPerPage"></jhi-item-count>
						<span style="margin-left: 20px;">{{'global.selected'|translate}}:</span>
						<span class="fw-bold pl-2">
							{{ isSelectAll ? totalItems : selectedItems.size }}
						</span>
						<div class="form-check form-check-inline" style="margin-left: 20px;">
							<input (click)="onSelectAll(isSelectAll)" [checked]="isSelectAll" class="form-check-input" id="check-select-all" name="check-select-all" [ngbTooltip]="'global.select.all' | translate" type="checkbox">
							<label class="form-check-label pl-2" for="check-select-all" jhiTranslate="global.select.all">
								Select all pages
							</label>
						</div>
						<div class="ms-2" style="margin-left: 10px;">
							<button class="btn btn-sm btn-outline-info" (click)="onClearSort($event)" jhiTranslate="global.clear-sort"></button>
						</div>
						<span *ngIf="isLoading" class="throbber" style="margin-left: 10px;"></span>
					</div>
				</div>
				<div class="col-4">
					<jhi-columns-dropdown (columnsSelectedEvent)="onColumnsSelected($event)" [selectedTraits]="selectedTraits" [staticColumns]="staticColumns"
											 class="ms-2 float-end">
					</jhi-columns-dropdown>
				</div>
			</div>
			<div class="table-responsive custom-scroll-style" style="height: auto; overflow: auto">
				<table class="table table-striped table-bordered table-curved">
					<thead>
					<tr jhiSort [(predicate)]="predicate" [(ascending)]="reverse" [callback]="transition.bind(this)">
						<th *ngIf="!isSelectAll"><input (click)="onSelectPage()" [checked]="isPageSelected()" [title]="'global.select.current.page' | translate" class="form-check-input" data-test="selectCurrentPageCheckbox" [ngbTooltip]="'global.select.current.page' | translate" type="checkbox"></th>
						<th [hidden]="hiddenColumns[ColumnLabels['ENV']]">
							<span jhiSortBy="gp.nd_geolocation_id">
								<span jhiTranslate="multi-trait-query.panel.specify.and.weight.the.environments.environment.table.header.environment.no"></span><span
								class="fa fa-sort"></span>
							</span>
						</th>
						<th [hidden]="hiddenColumns[ColumnLabels['LOCATION']]">
							<span jhiSortBy="l.lname">
								<span jhiTranslate="multi-trait-query.panel.specify.and.weight.the.environments.environment.table.header.location"></span><span class="fa fa-sort"></span>
							</span>
						</th>
						<th [hidden]="hiddenColumns[ColumnLabels['COUNTRY']]">
							<span jhiSortBy="c.isoabbr">
								<span jhiTranslate="multi-trait-query.panel.specify.and.weight.the.environments.environment.table.header.country"></span><span class="fa fa-sort"></span>
							</span>
						</th>
						<th [hidden]="hiddenColumns[ColumnLabels['STUDY']]">
							<span jhiSortBy="p.name">
								<span jhiTranslate="multi-trait-query.panel.specify.and.weight.the.environments.environment.table.header.study"></span><span class="fa fa-sort"></span>
							</span>
						</th>
						<th [hidden]="hiddenColumns[ColumnLabels['WEIGHT']]" [ngStyle]="{ 'width': '120px' }">
							<span jhiTranslate="multi-trait-query.panel.specify.and.weight.the.environments.environment.table.header.weight"></span>
						</th>
						<ng-container *ngIf="environmentDetailColumns">
							<th *ngFor="let entry of environmentDetailColumns">
								<span jhiSortBy="{{'COLUMN_' + entry.id}}">
									<span>{{ entry.name }}</span>
									<span class="fa fa-sort"></span>
								</span>
							</th>
						</ng-container>
					</tr>
					</thead>
					<tbody *ngIf="traitEnvironments.length else nodata">
					<tr *ngFor="let traitEnvironment of traitEnvironments; trackBy: trackId; index as index">
						<td *ngIf="!isSelectAll">
							<input (click)="toggleSelect($event, index, traitEnvironment, true); $event.stopPropagation()" [checked]="isSelected(traitEnvironment)" class="form-check-input" type="checkbox">
						</td>
						<td [hidden]="hiddenColumns[ColumnLabels['ENV']]">{{ traitEnvironment.id }}</td>
						<td [hidden]="hiddenColumns[ColumnLabels['LOCATION']]">{{ traitEnvironment.locationName }}</td>
						<td [hidden]="hiddenColumns[ColumnLabels['COUNTRY']]">{{ traitEnvironment.isoAbbr }}</td>
						<td [hidden]="hiddenColumns[ColumnLabels['STUDY']]">{{ traitEnvironment.studyName }}</td>
						<td [hidden]="hiddenColumns[ColumnLabels['WEIGHT']]" [ngStyle]="{ 'min-width': '120px' }">
							<select (ngModelChange)="selectedWeight(traitEnvironment)" [(ngModel)]="traitEnvironment.weight"
									[disabled]="!isSelected(traitEnvironment) && !isSelectAll"
									class="form-select">
								<option *ngIf="!isSelected(traitEnvironment)  && !isSelectAll" [value]="Weight.IGNORED">
									{{'head-to-head-query.environment.weight.ignored' | translate}}
								</option>
								<ng-container *ngIf="!!isSelected(traitEnvironment) || isSelectAll">
									<option *ngFor="let opt of environmentWeightOptions" [value]="opt.value">
										{{ opt.label | translate }}
									</option>
								</ng-container>
							</select>
						</td>
						<td *ngFor="let entry of environmentDetailColumns ">{{ traitEnvironment.variables["COLUMN_" + entry.id] }}</td>
					</tr>
					</tbody>
				</table>
				<ng-template #nodata>
					<tbody>
					<tr>
						<td [attr.colspan]="colspan()" jhiTranslate="no.data"></td>
					</tr>
					</tbody>
				</ng-template>
			</div>
			<div *ngIf="traitEnvironments && traitEnvironments.length">
				<div class="row">
					<div class="col">
						<div class="pagination-container">
							<div class="pagination-box pagination-box-left">
								<div>
									<jhi-item-count [page]="page" [total]="totalItems" [itemsPerPage]="itemsPerPage"></jhi-item-count>
								</div>
							</div>
							<div class="pagination-box">
								<ngb-pagination [collectionSize]="totalItems" [(page)]="page" [pageSize]="itemsPerPage" [disabled]="isLoading"
												[maxSize]="5" [rotate]="true" [boundaryLinks]="true" (pageChange)="loadPage(page)"></ngb-pagination>
							</div>
							<div class="pagination-box pagination-box-right">
								<div class="d-flex align-items-center">
									<label class="control-label control-label-left" for="itemsPerPage" jhiTranslate="global.items.per.page"></label>
									<select [(ngModel)]="itemsPerPage" class="form-select ms-2" id="itemsPerPage" [disabled]="isLoading" (change)="resetTable();" style="width:95px">
										<option value="20">20</option>
										<option value="50">50</option>
										<option value="75">75</option>
										<option value="100">100</option>
									</select>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col-md-12 align-center">
			<button (click)="onBack()" class="btn btn-secondary ms-2" jhiTranslate="back"></button>
			<button (click)="onNext()" [disabled]="!isNextEnabled()" class="btn btn-primary ms-2" jhiTranslate="next"></button>
		</div>
	</div>
</div>
